import { render, staticRenderFns } from "./JamesonTeaser.vue?vue&type=template&id=620b753a&scoped=true"
import script from "./JamesonTeaser.vue?vue&type=script&lang=js"
export * from "./JamesonTeaser.vue?vue&type=script&lang=js"
import style0 from "./JamesonTeaser.vue?vue&type=style&index=0&id=620b753a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620b753a",
  null
  
)

export default component.exports